import { PLATFORM } from 'aurelia-pal';

import { ProductFeedsProductsListManager } from './services/productFeedsProductsList';
import { ProductFeedsProducts } from './services/productFeedsProducts';
import { ProductFeedsSettings } from './services/productFeedsSettings';
import { SelectedAccountOptions } from './services/selectedAccountOptions';
import { SelectedProductOptions } from './services/selectedProductOptions';
import { SelectedJobOptions } from './services/selectedJobOptions';

const activitiesContainer = PLATFORM
.moduleName('./containers/activities/activities.container');
const jobContainer = PLATFORM
.moduleName('./containers/job/job.container');
const jobsContainer = PLATFORM
.moduleName('./containers/jobs/jobs.container');
const newJobModalContainer = PLATFORM
.moduleName('./containers/newJobModal/newJobModal.container');
const productFeedsNavigationContainer = PLATFORM
.moduleName('./containers/productFeedsNavigation/productFeedsNavigation.container');
const productFeedsProductsContainer = PLATFORM
.moduleName('./containers/productFeedsProducts/productFeedsProducts.container');
const productFeedsSettingsContainer = PLATFORM
.moduleName('./containers/productFeedsSettings/productFeedsSettings.container');
const productSettingsContainer = PLATFORM
.moduleName('./containers/productSettings/productSettings.container');
const productCategoriesContainer = PLATFORM
.moduleName('./containers/productCategories/productCategories.container');
const productIdsContainer = PLATFORM
.moduleName('./containers/productIds/productIds.container');
const productExtrasContainer = PLATFORM
.moduleName('./containers/productExtras/productExtras.container');
const productSyndicationContainer = PLATFORM
.moduleName('./containers/productSyndication/productSyndication.container');

const activitiesList = PLATFORM
.moduleName('./components/activitiesList/activitiesList');
const newJobForm = PLATFORM
.moduleName('./components/newJobForm/newJobForm');
const productDetail = PLATFORM
.moduleName('./components/productDetail/productDetail');
const productDetailSection = PLATFORM
.moduleName('./components/productDetailSection/productDetailSection.html');
const productFeedsJobsList = PLATFORM
.moduleName('./components/productFeedsJobsList/productFeedsJobsList');
const productFeedsJobViewer = PLATFORM
.moduleName('./components/productFeedsJobViewer/productFeedsJobViewer');
const productFeedsSection = PLATFORM
.moduleName('./components/productFeedsSection/productFeedsSection.html');
const productFeedsSectionHeader = PLATFORM
.moduleName('./components/productFeedsSectionHeader/productFeedsSectionHeader.html');
const productFeedsProductsList = PLATFORM
.moduleName('./components/productFeedsProductsList/productFeedsProductsList');
const productFeedsSettingsForm = PLATFORM
.moduleName('./components/productFeedsSettingsForm/productFeedsSettingsForm');
const productGenericDetail = PLATFORM
.moduleName('./components/productGenericDetail/productGenericDetail');

/**
 * The configuration of the product feeds plugin/module.
 * @param {FrameworkConfiguration} frameworkConfig The object the framework uses to configure
 *                                                 resources.
 */
export const configure = (frameworkConfig) => {
  // Services
  frameworkConfig.container.registerSingleton(
    'productFeedsProductsListManager',
    ProductFeedsProductsListManager,
  );
  frameworkConfig.container.registerSingleton(
    'productFeedsProducts',
    ProductFeedsProducts,
  );
  frameworkConfig.container.registerSingleton(
    'productFeedsSettings',
    ProductFeedsSettings,
  );
  frameworkConfig.container.registerSingleton(
    'selectedAccountOptions',
    SelectedAccountOptions,
  );
  frameworkConfig.container.registerSingleton(
    'selectedProductOptions',
    SelectedProductOptions,
  );
  frameworkConfig.container.registerSingleton(
    'selectedJobOptions',
    SelectedJobOptions,
  );

  // Resources
  frameworkConfig.globalResources(
    jobContainer,
    jobsContainer,
    newJobModalContainer,
    activitiesContainer,
    productFeedsNavigationContainer,
    productFeedsProductsContainer,
    productFeedsSettingsContainer,
    productSettingsContainer,
    productCategoriesContainer,
    productIdsContainer,
    productExtrasContainer,
    productSyndicationContainer,
    activitiesList,
    newJobForm,
    productDetail,
    productDetailSection,
    productFeedsJobsList,
    productFeedsJobViewer,
    productFeedsSection,
    productFeedsSectionHeader,
    productFeedsProductsList,
    productFeedsSettingsForm,
    productGenericDetail,
  );
};
